<template>
  <div class="chat-image">
    <b-spinner v-if="loading" small />
    <div v-else-if="error" class="chat-image__error">
      <feather-icon icon="ImageIcon" size="14" /> Image unavailable
    </div>
    <img v-else :src="objectUrl" class="chat-image__img" alt="Sent image" @click="openFull" />

    <b-modal
      v-model="previewVisible"
      centered
      hide-header
      hide-footer
      body-class="chat-image__preview-body"
      size="lg"
    >
      <button type="button" class="chat-image__preview-close" aria-label="Close" @click="previewVisible = false">
        <feather-icon icon="XIcon" size="20" />
      </button>
      <img :src="objectUrl" class="chat-image__preview-img" alt="Sent image" />
    </b-modal>
  </div>
</template>

<script>
import chatbotAxios from '@/libs/chatbot-axios'
import { BSpinner, BModal } from 'bootstrap-vue'

export default {
  name: 'ChatImage',
  components: { BSpinner, BModal },
  props: {
    messageId: { type: String, required: true },
  },
  data() {
    return {
      loading: true,
      error: false,
      objectUrl: null,
      previewVisible: false,
    }
  },
  watch: {
    messageId: 'load',
  },
  mounted() {
    this.load()
  },
  beforeDestroy() {
    this.revoke()
  },
  methods: {
    async load() {
      this.revoke()
      this.loading = true
      this.error = false
      try {
        const { data } = await chatbotAxios.get(`/api/v1/line-image/${this.messageId}`, { responseType: 'blob' })
        this.objectUrl = URL.createObjectURL(data)
      } catch (e) {
        this.error = true
      } finally {
        this.loading = false
      }
    },
    revoke() {
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl)
        this.objectUrl = null
      }
    },
    openFull() {
      if (this.objectUrl) this.previewVisible = true
    },
  },
}
</script>

<style scoped>
.chat-image__img {
  max-width: 220px;
  max-height: 220px;
  border-radius: 8px;
  cursor: pointer;
  display: block;
}
.chat-image__error {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>

<style>
.chat-image__preview-body {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}
.chat-image__preview-img {
  max-width: 100%;
  max-height: 80vh;
  display: block;
}
.chat-image__preview-close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  cursor: pointer;
}
.chat-image__preview-close:hover {
  background: rgba(0, 0, 0, 0.7);
}
</style>
